export default {
  state: {
    inventoryOverview: {
      summary_by_stock_age_scope_list: [],
      stock_age_scope_name: '',
      time_tag: '',
      time_custom: [],
      stock_trend_tag: ''
    }
  },
  getters: {
    getInventoryOverview(state){
      return state.inventoryOverview;
    },
    getSummaryByStockAgeScopeList(state){
      return state.inventoryOverview.summary_by_stock_age_scope_list;
    },
    getStockAgeScopeName(state){
      return state.inventoryOverview.stock_age_scope_name;
    },
    getTimeTag(state){
      return state.inventoryOverview.time_tag;
    },
    getTimeCustom(state){
      return state.inventoryOverview.time_custom;
    },
    getStockTrendTag(state){
      return state.inventoryOverview.stock_trend_tag;
    }
  },
  mutations: {
    setInventoryOverview(state, param){
      state.inventoryOverview = param;
    },
    setSummaryByStockAgeScopeList(state, param){
      state.inventoryOverview.summary_by_stock_age_scope_list = param;
    },
    setStockAgeScopeName(state, param){
      state.inventoryOverview.stock_age_scope_name = param;
    },
    setTimeTag(state, param){
      state.inventoryOverview.time_tag = param;
    },
    setTimeCustom(state, param){
      state.inventoryOverview.time_custom = param;
    },
    setStockTrendTag(state, param){
      state.inventoryOverview.stock_trend_tag = param;
    }
  },
  actions: {
    setInventoryOverview(context, param){
      context.commit('setInventoryOverview', param);
    },
    setSummaryByStockAgeScopeList(context, param){
      context.commit('setSummaryByStockAgeScopeList', param);
    },
    setStockAgeScopeName(context, param){
      context.commit('setStockAgeScopeName', param);
    },
    setTimeTag(context, param){
      context.commit('setTimeTag', param);
    },
    setTimeCustom(context, param){
      context.commit('setTimeCustom', param);
    },
    setStockTrendTag(context, param){
      context.commit('setStockTrendTag', param);
    }
  }
}



// WEBPACK FOOTER //
// ./src/store/inventory-overview.js